// extracted by mini-css-extract-plugin
export default {"wrap":"separator_wrap__2bI-P"};